import getApiClient from 'src/utils/getApiClient'
import type { PatientProfileData } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/components/PatientProfile/types'

const PATIENT_PROFILE_API_PATH = '/api/rates/patient_profile/'
const apiClient = getApiClient()

export default function getPatientData(params: {
  patientProfileId?: string
  patientId?: string
}) {
  return apiClient.get<Omit<PatientProfileData, 'isLoaded' | 'title' | 'id'>>(
    PATIENT_PROFILE_API_PATH,
    {
      params: {
        patient_id: params.patientId,
        patient_profile_id: params.patientProfileId,
      },
    },
  ).then(response => response.data)
}
